'use client';

import React, { useEffect, useRef } from 'react';

const audiences = [
  {
    role: 'CFO Organisations',
    desc: 'Finance leaders looking to implement structured, driver-based planning in SAC — moving beyond spreadsheets and legacy planning tools.',
  },
  {
    role: 'FP&A Teams',
    desc: 'Planning and analysis teams responsible for budget, forecast, and management reporting who need a more disciplined SAC Planning architecture.',
  },
  {
    role: 'SAP Transformation Programs',
    desc: 'S/4HANA implementation programs that need SAC Planning designed and built in parallel, aligned to the new finance data model.',
  },
  {
    role: 'Enterprise Architects',
    desc: 'Architecture teams evaluating SAC Planning as part of a broader SAP analytics and planning landscape design.',
  },
  {
    role: 'Planning COE Teams',
    desc: 'Centre of Excellence teams responsible for sustaining and evolving SAC Planning — needing governance frameworks and model improvement support.',
  },
];

export default function WhoThisIsFor() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-on-scroll').forEach((el) => {
              (el as HTMLElement).classList.add('is-visible');
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 px-6 border-b border-border bg-secondary">
      <div className="max-w-container mx-auto">
        <div className="mb-12 reveal-on-scroll">
          <div className="mono-label mb-3">Audience</div>
          <h2
            className="font-heading font-semibold text-foreground"
            style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)', letterSpacing: '-0.025em' }}
          >
            Who This Is For
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {audiences.map((a, i) => (
            <div
              key={a.role}
              className={`reveal-on-scroll reveal-delay-${i + 1} bg-white border border-border p-6`}
              style={{ borderRadius: '4px' }}
            >
              <h3 className="font-heading font-semibold text-foreground text-sm mb-3">{a.role}</h3>
              <p className="text-sm text-muted leading-relaxed font-body">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}